import { useMemo } from 'react';
import getBaseColumns from '../utils';
import useLanguage from '@op/hooks/useLanguage';
import { summaryListColumnFunc } from '../columns/userSummaryList';
import { useGameOperations } from '@op/utils/game';
import '../scss/userSummaryList.scss';

export function useSummaryListColumns({
  clickDelete,
  clickPreview,
  clickDownload,
  clickStop,
  clickResume,
  toggleModal,
  keys = [
    'analysis_name',
    'category',
    'create_time',
    'creator',
    'status',
    'action',
  ],
  noNewTagsReport,
  newTagLoading,
  gameInfoMap,
  sortColumns = ['create_time'],
  tab,
  onOpenPermissionPanel,
}: any) {
  const { formatMessage } = useLanguage();
  const { handleChangeGame } = useGameOperations();

  const columns = useMemo(() => {
    const columnsMap = summaryListColumnFunc({
      formatMessage,
      clickDownload,
      clickPreview,
      clickDelete,
      clickStop,
      clickResume,
      toggleModal,
      noNewTagsReport,
      newTagLoading,
      gameInfoMap,
      handleChangeGame,
      tab,
      onOpenPermissionPanel,
    });
    return getBaseColumns(keys, columnsMap);
  }, [formatMessage, keys, noNewTagsReport, newTagLoading, gameInfoMap]);

  return { columns, sortColumns };
}
